import { Action } from '@ngrx/store';
import * as models from '../../domain/models';
import { Lookup } from '../../../../shared/models';

export const LOAD = '[RM Airport Collection] Load';
export const LOAD_SUCCESS = '[RM Airport Collection] Load Success';
export const LOAD_FAIL = '[RM Airport Collection] Load Fail';

export class LoadPayload {
  constructor(public lookup: Lookup) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public items: Array<models.Airport>, public total: number) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class SearchPayload {
  constructor(public criteria: string) {}
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
